<button
    ds-button
    msThemedButton
    kind="success"
    variant="filled"
    size="large"
    truncate="true"
    [themeKind]="buttonThemeKind"
    [disabled]="disabled"
    (click)="onClick()">
    @if (!props.hasOfferChanges) {
        {{ texts.acceptChangesAndPlaceBet }}
    } @else {
        {{ texts.acceptChanges }}
    }
</button>
